import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ReportService } from '../../services/report.service';
import { DataFormModel } from '../../models/data-form-model.model';
import { FormGroup, Validators } from '@angular/forms';
import { AmenityService } from '../../services/amenity.service';
import { StreetBuildingService } from '../../services/street-building.service';
import { UtilService } from '../../services/util.service';
import { ImageService } from '../../services/image.service';
import { SpinnerService } from '../../services/spinner.service';

@Component({
  selector: 'app-create-report-modal',
  templateUrl: './create-report-modal.component.html',
  styleUrl: './create-report-modal.component.scss'
})
export class CreateReportModalComponent {

  @Input() neighborhoodId!: string;

  public formReport!: FormGroup;
  public submitted: boolean = false;
  public loading: boolean = true;

  public uploadedFiles: string[] = [];

  public dataForm: DataFormModel = {
    title: {
      value: '',
      type: 'text',
      label: 'Título del reporte',
      requiredMessage: 'Por favor, ingrese un título para el reporte',
      required: true,
      validators: [Validators.required]
    },
    description: {
      value: '',
      type: 'textarea',
      label: 'Descripción del reporte',
      requiredMessage: 'Por favor, ingrese una descripción para el reporte',
      required: true,
      validators: [Validators.required]
    },
    amenityId: {
      value: null,
      type: 'select',
      idSelect: 'amenityId',
      labelSelect: 'name',
      data: [],
      label: 'Amenidad',
      placeholder: 'Seleccione una amenidad (opcional)',
      required: false,
      validators: []
    },
    streetBuildingId: {
      value: null,
      type: 'select',
      idSelect: 'streetBuildingId',
      labelSelect: 'name',
      data: [],
      label: 'Calle',
      placeholder: 'Seleccione una calle (opcional)',
      required: false,
      validators: [],
      onChange: (value) => {
        
        console.log(
          value
        );

        if(value) {

          const streetBuilding = this.streetBuildingService.streetsBuildings.find(
            (sb) => sb.streetBuildingId === value
          );

          if(streetBuilding) {
            
            this.dataForm['houseFlatId'].data = streetBuilding.housesFlats;
            this.formReport.controls['houseFlatId'].setValue(null);

          }

        }  else {

          this.dataForm['houseFlatId'].data = [];
          this.formReport.controls['houseFlatId'].setValue(null);

        }

      },
    },
    houseFlatId: {
      value: null,
      type: 'select',
      idSelect: 'number',
      labelSelect: 'number',
      data: [],
      label: 'Casa / Departamento',
      placeholder: 'Seleccione una casa / departamento (opcional)',
      required: false,
      validators: []
    }
  };

  constructor(
    public activeModal: NgbActiveModal,
    public amenityService: AmenityService,
    private imageService: ImageService,
    private reportService: ReportService,
    public spinnerService: SpinnerService,
    public streetBuildingService: StreetBuildingService,
    public utilService: UtilService
  ) { }

  ngOnInit(): void {
    this.loadData();
  }

   get f() {
    return this.formReport.controls;
  }

  /* -------------------------------------------------------------------------- */
  /*                             ANCHOR compressFile                            */
  /* -------------------------------------------------------------------------- */
  // region compressFile
  async compressFile() {

    const result = await this.imageService.compressFile();
    this.uploadedFiles.push(...result);

    console.log(this.uploadedFiles);
    
  }

  /* -------------------------------------------------------------------------- */
  /*                               ANCHOR loadData                              */
  /* -------------------------------------------------------------------------- */
  // region loadData
  async loadData() {

    this.loading = true;

    await this.amenityService.getAll(
      this.neighborhoodId
    );

    this.dataForm['amenityId'].data = this.amenityService.amenities;

    await this.streetBuildingService.getAll(
      this.neighborhoodId
    );

    this.dataForm['streetBuildingId'].data = this.streetBuildingService.streetsBuildings;

    this.formReport = this.utilService.buildForm(this.dataForm);

    this.loading = false;
  }

  /* -------------------------------------------------------------------------- */
  /*                               ANCHOR onSubmit                              */
  /* -------------------------------------------------------------------------- */
  // region onSubmit
  async onSubmit() {

    console.log(this.formReport.value);
    
    this.submitted = true;

    if(this.formReport.invalid) {
      return;
    }

    const reportResult = await this.reportService.create(
      this.neighborhoodId,
      this.formReport.value
    );

    if(reportResult) {

      if(this.uploadedFiles.length > 0) {

        for(let i = 0; i < this.uploadedFiles.length; i++) {

          this.spinnerService.loading = true;

          const file = this.utilService.base64ToFile(
            this.uploadedFiles[i],
            `report-image-${i + 1}.jpg`
          );

          console.log(file);
          
          const uploadFlag = await this.reportService.uploadImage(
            reportResult,
            file,
            file.type,
            `Foto ${i + 1}`,
            {
              index: i + 1,
              total: this.uploadedFiles.length
            }
          );

        }

        this.spinnerService.loading = false;
        this.spinnerService.message = '';

      }

      for(let key of Object.keys(this.dataForm)) {
        this.dataForm[key].value = '';
      }

      this.activeModal.close();
    }

  }

}
